import React from 'react';
import { Section } from './ui/Section';
export function ForWho() {
  const points = [{
    title: 'Eres buena instructora pero te falta estructura pedagógica real',
    desc: 'Sabes moverte y enseñar, pero necesitas un sistema profesional que respalde tu talento.'
  }, {
    title: 'Tus alumnas no sienten que progresan y te da miedo que se vayan',
    desc: 'Necesitas una metodología clara de progresión que mantenga a tus alumnas motivadas mes tras mes.'
  }, {
    title: 'Quieres cobrar más pero no sabes cómo hacerlo sin perder a nadie',
    desc: 'Necesitas la escalera de precios y el posicionamiento correcto para subir tarifas con confianza.'
  }, {
    title: 'No tienes tiempo de planificar desde cero cada semana',
    desc: 'Necesitas un sistema de planificación que te ahorre 5+ horas semanales sin sacrificar calidad.'
  }, {
    title: 'Quieres una sala llena de forma predecible sin depender del boca a boca',
    desc: 'Necesitas un sistema de marketing que capture alumnas nuevas de forma constante y automática.'
  }];
  return <Section data-id="element-143">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-144">
        💡 ESTE MANUAL ES PARA TI SI...
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-145">
        {points.map((point, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl p-6 shadow-card hover:shadow-violet-glow transition-all hover:border-brand-borderGlow/60 flex items-start gap-4" data-id="element-146">
            <span className="text-brand-success text-2xl shrink-0" data-id="element-147">✅</span>
            <div data-id="element-148">
              <h3 className="font-heading font-bold text-brand-text mb-2 tracking-wide" data-id="element-149">
                {point.title}
              </h3>
              <p className="font-body text-brand-textMuted text-sm" data-id="element-150">
                {point.desc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}